const baseClass = '.saig-o-carousel';
const getElClass = (elClass?: string) => (elClass ? `${baseClass}__${elClass}` : baseClass);

const carousels = document.querySelectorAll<HTMLElement>(getElClass());
const animDuration = 600;
let interval: number;

const handler = (carousel: HTMLElement) => {
  var carouselContent = carousel.querySelector<HTMLDivElement>(getElClass('slides'));
  const dataInterval = carousel.getAttribute('data-interval');

  if (dataInterval && parseInt(dataInterval) > animDuration) {
    interval = parseInt(dataInterval);
  }

  var slides = carousel.querySelectorAll<HTMLElement>(getElClass('slide'));
  const nextBtn = carousel.querySelector<HTMLElement>(getElClass('next'));
  const prevBtn = carousel.querySelector<HTMLElement>(getElClass('back'));
  const allDots = carousel.querySelectorAll(getElClass('dot'));
  const dotsWrapper = carousel.querySelector(getElClass('dots'));

  if (slides.length <= 1) {
    nextBtn?.classList.add('hidden');
    prevBtn?.classList.add('hidden');
    dotsWrapper?.classList.add('hidden');
  }

  const setupHeight = () => {
    let wrapperHeight = 0;

    [].forEach.call(slides, function (el: HTMLElement) {
      const divChild = el.querySelector<HTMLElement>('div');

      if (divChild && wrapperHeight < divChild.getBoundingClientRect().height) {
        wrapperHeight = divChild.getBoundingClientRect().height;
      }
    });

    carouselContent && setWrapperHeight(carouselContent, wrapperHeight);
  };

  setupHeight();

  setInterval(() => {
    setupHeight();
  }, 1000);

  window.addEventListener('resize', setupHeight.bind(null));

  function setWrapperHeight(el: HTMLElement, height: number) {
    el!.style.height = height + 'px';
  }

  let currImg = 0,
    prevImg = slides.length - 1,
    intrvl: NodeJS.Timer,
    timeout: NodeJS.Timeout;

  allDots[0].classList.add('active-dot');
  slides[0].style.left = '0';

  if (interval && slides.length > 1) {
    timeout = setTimeout(() => {
      animateSlider();
      slides[0].style.left = '';
      if (interval) intrvl = setInterval(animateSlider, interval);
    }, interval - animDuration);
  }

  [].forEach.call(allDots, (dot: HTMLElement, index: number) => {
    dot.addEventListener('click', dotClick.bind(null, index));
  });
  nextBtn?.addEventListener('click', () => {
    animateSlider();
    clear();

    if (interval) intrvl = setInterval(animateSlider, interval);
  });
  prevBtn?.addEventListener('click', () => {
    animateSlider(-1, true);
    clear();
    if (interval) intrvl = setInterval(animateSlider, interval);
  });

  function animateSlider(nextImg?: number, right?: boolean) {
    if (slides.length <= 1) return;

    if (!nextImg) nextImg = currImg + 1 < slides.length ? currImg + 2 : 1;

    if (nextImg === -1) {
      nextImg = currImg - 1 >= 0 ? currImg : slides.length;
    }

    --nextImg;
    slides[prevImg].style.animationName = '';

    if (!right) {
      slides[nextImg].style.animationName = 'leftNext';
      slides[currImg].style.animationName = 'leftCurr';
    } else {
      slides[nextImg].style.animationName = 'rightNext';
      slides[currImg].style.animationName = 'rightCurr';
    }

    prevImg = currImg;
    currImg = nextImg;

    let currDot = allDots[currImg];
    currDot.classList.add('active-dot');
    let prevDot = allDots[prevImg];
    prevDot.classList.remove('active-dot');
  }

  function dotClick(num: number) {
    if (num == currImg) return false;

    if (num > currImg) animateSlider(num + 1);
    else animateSlider(num + 1, true);
    clear();

    if (interval) intrvl = setInterval(animateSlider, interval);
  }

  function clear() {
    clearTimeout(timeout);
    clearInterval(intrvl);
    slides[0].style.left = '';
  }
};

[].forEach.call(carousels, handler);

export {};
